import { Pipe, PipeTransform } from '@angular/core';
import { AuthGateway } from '../application/gateway/AuthGateway';
import { TranslateService } from '@ngx-translate/core';
import { Pallet } from '../domain/models/Pallet';
import { PalletUtils } from '../ui/util/pallets-utils';

@Pipe({
  name: 'BoxesPerPalletFactor'
})
export class BoxesPerPalletFactorPipe implements PipeTransform {

  transform(pallet:Pallet): number {
     return PalletUtils.calculateBoxesPerPallet(pallet)
  }
}
